import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';

const uploadMonthlyQuota = (formData, year, month) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const host = useExpress ? getExpressAPIHost() : getAPIHost();
        // Split-gate both host AND path: Express uses /users/upload-monthly-quotas/...;
        // LoopBack uses the un-namespaced /upload-monthly-quotas/...
        const path = useExpress ? `/users/upload-monthly-quotas/${year}/${month}` : `/upload-monthly-quotas/${year}/${month}`;
        axios
            .post(`${host}${path}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch(() => {
                reject(new Error('Unable to upload file'));
            });
    });

export default uploadMonthlyQuota;
